import { useState } from "react";
import { hotCards } from "@/mocks/gossip";

const filters = ["全部", "综艺", "明星", "影视", "直播", "情感", "财经"];

export default function HotFeed() {
  const [active, setActive] = useState("全部");
  const list = active === "全部" ? hotCards : hotCards.filter((c) => c.cat === active);

  return (
    <section id="hot" className="scroll-mt-20 bg-background-50 py-12 md:py-16">
      <div className="mx-auto max-w-[1200px] px-4 md:px-6">
        <div className="flex flex-col gap-4 lg:flex-row lg:items-end lg:justify-between">
          <div>
            <p className="inline-flex items-center gap-1.5 text-xs font-semibold uppercase tracking-wider text-primary-600">
              <i className="ri-fire-line text-sm" />
              实时瓜田
            </p>
            <h2 className="font-heading mt-2 text-2xl font-bold text-foreground-900 md:text-3xl">正在热吃，大图直给</h2>
            <p className="mt-2 max-w-xl text-sm text-foreground-600">
              标题先亮，配图克制。热门瓜料合集按热度实时排布，点哪篇看哪篇，全部免费解锁。
            </p>
          </div>
          <div className="inline-flex flex-wrap items-center gap-1 rounded-full border border-background-200/80 bg-background-100/60 p-1">
            {filters.map((f) => (
              <button
                key={f}
                type="button"
                onClick={() => setActive(f)}
                className={`whitespace-nowrap rounded-full px-4 py-1.5 text-sm font-medium transition-colors ${
                  active === f
                    ? "bg-primary-500 text-background-50"
                    : "text-foreground-600 hover:bg-secondary-100 hover:text-foreground-900"
                }`}
              >
                {f}
              </button>
            ))}
          </div>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {list.map((card) => (
            <article
              key={card.id}
              className="group flex cursor-pointer flex-col overflow-hidden rounded-lg border border-background-200/70 bg-background-100/40 transition-colors hover:border-primary-200"
            >
              <div className="relative aspect-[3/2] w-full overflow-hidden bg-background-200">
                <img
                  src={card.img}
                  alt={card.title}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute left-3 top-3 flex items-center gap-2">
                  <span className="rounded-md bg-foreground-950/70 px-2 py-0.5 text-[11px] font-semibold text-background-50 backdrop-blur">
                    {card.cat}
                  </span>
                  {card.fresh && (
                    <span className="flex items-center gap-1 rounded-md bg-accent-500 px-2 py-0.5 text-[11px] font-semibold text-background-50">
                      <i className="ri-flashlight-fill text-[11px]" /> 新
                    </span>
                  )}
                </div>
                {card.trend && (
                  <div className="absolute right-3 top-3 flex h-7 w-7 items-center justify-center rounded-full bg-primary-500 text-background-50">
                    <i className="ri-fire-fill text-sm" />
                  </div>
                )}
              </div>

              <div className="flex flex-1 flex-col p-4">
                <h3 className="line-clamp-2 min-h-[2.8rem] text-sm font-bold leading-relaxed text-foreground-900 transition-colors group-hover:text-primary-700">
                  {card.title}
                </h3>
                <p className="mt-2 line-clamp-2 text-xs leading-relaxed text-foreground-500">{card.excerpt}</p>
                <div className="mt-auto flex items-center justify-between border-t border-background-200/70 pt-3 text-xs text-foreground-400">
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-time-line" />
                    {card.time}
                  </span>
                  <span className="inline-flex items-center gap-1 font-semibold text-primary-600">
                    <i className="ri-fire-line" />
                    {card.heat}
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>

        <div className="mt-8 text-center">
          <a
            href="#hot"
            className="inline-flex whitespace-nowrap items-center gap-2 rounded-md border border-primary-200 bg-primary-50 px-6 py-2.5 text-sm font-semibold text-primary-700 transition-colors hover:bg-primary-100"
          >
            加载更多热门瓜料
            <i className="ri-arrow-down-line" />
          </a>
        </div>
      </div>
    </section>
  );
}